import React, { useEffect, useState } from "react"
import moment from "moment"
import EditPost from "./EditPost"
import { CheckCircle } from "@material-ui/icons"
import { useAuth } from "../firebase/useAuth"
import { truncate } from "../helpers/functions"
import { LazyLoadImage, LazyLoadComponent } from "react-lazy-load-image-component"
import "react-lazy-load-image-component/src/effects/blur.css"
import noImg from "../assets/no-img.png"
import ReactPlayer from "react-player"

export default function GridItem(props) {
  const { post, index } = props
  const [currentUser] = useAuth()

  const [openModal, setOpenModal] = useState(false)
  const [images, setImages] = useState([])
  const [done, setDone] = useState(false)
  const [description, setDescription] = useState("")
  const [hashtags, setHashtags] = useState([])
  const [plannedFor, setPlannedFor] = useState(null)

  const date = moment(currentUser?.startingDate).add(index, "days").format("DD/MM/YY")

  useEffect(() => {
    setImages(post.images)
    setDone(post.done)
    setDescription(post.description)
    setHashtags(post.hashtags)
    setPlannedFor(post.plannedFor)
  }, [post])

	return (
		<>
			<div className="grid-item" onClick={() => setOpenModal(true)}>
				<div className="content">
          {images[0] && images[0]?.type === "video" ? (
            <LazyLoadComponent>
              <ReactPlayer
                url={images[0]?.src}
                className="postImg" 
                playing={false}
              />
            </LazyLoadComponent>
          ) : (
            <LazyLoadImage 
              src={images[0]?.src || noImg}
              alt={images[0]?.src || noImg}
              className="postImg"
              style={images.length < 1 ? { objectFit: "cover" } : {}}
              effect="blur"
            />
          )}
          {post.description && <div className="description">{truncate(post.description, 140)}</div>}
					<div className="date">{moment(post?.plannedFor).format("DD/MM/YY à hh:mm")}</div>
				</div>
        {done && (
          <div className="overlay">
            <CheckCircle className="doneIcon" />
          </div>
        )}
			</div>
      <EditPost
        open={openModal} 
        onClose={() => setOpenModal(false)} 
        post={post}
        images={images}
        setImages={setImages}
        description={description}
        setDescription={setDescription}
        hashtags={hashtags}
        setHashtags={setHashtags}
        plannedFor={plannedFor}
        setPlannedFor={setPlannedFor}
        done={done}
        setDone={setDone}
      />
		</>
	)
}
